import { render, staticRenderFns } from "./UserDeactivation.vue?vue&type=template&id=a4393e5a&scoped=true"
import script from "./UserDeactivation.vue?vue&type=script&lang=js"
export * from "./UserDeactivation.vue?vue&type=script&lang=js"
import style0 from "./UserDeactivation.vue?vue&type=style&index=0&id=a4393e5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4393e5a",
  null
  
)

export default component.exports